import {
  Box,
  Card,
  Checkbox,
  Grid,
  Radio,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import CustomTextField from "../../../components/customFields/CustomTextField";
import CustomSelectField from "../../../components/customFields/CustomSelectField";
import {
  deleteUserAddress,
  getAdressOfUser,
  getCityByState,
  getCountries,
  getStateByCountry,
} from "../../testPrepDashboard/Api/DashboardApi";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PinkSmallButton from "../../../components/customButtons/PinkSmallButton";
import PinkExtraSmallButton from "../../../components/customButtons/PinkExtraSmallButton";
import CustomPopup from "../../../components/customPopup/CustomPopup";
import AddNewAddress from "./AddNewAddress";
import NoAddressScreen from "./NoAddressScreen";
import ConfimationPopup from "../../../components/customPopup/ConfimationPopup";
import GlobalMessageModal from "../../../components/customPopup/GlobalMessageModal";
import DoneIcon from "@mui/icons-material/Done";
import { useLocation } from "react-router-dom";
import DeleteConfirmationPopup from "../../../components/customPopup/DeleteConfirmationPopup";
import SussceeffulyMessageScreen from "../../../components/customPopup/SussceeffulyMessageScreen";
import EditUserAddress from "./EditUserAddress";
import ErrorPopupScreen from "../../../components/customPopup/ErrorPopupScreen";
import Loader from "../../../../SAPPages/components/Loader/Loader";
import { useDispatch } from "react-redux";
import { setDefaultAddress } from "../../../../redux/features/userAddress/addressSlice"; // adjust the path

export default function BillingAddress() {
  const userId = localStorage.getItem("userId");
  const firstName = localStorage.getItem("firstName");
  const dispatch = useDispatch();
  const location = useLocation();
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [OpenNewAddress, SetOpenNewAddress] = useState(false);
  const [OpenEditAddress, setOpenEditAddress] = useState(false);
  const [addressLoading, setAddressloading] = useState(true);
  const [userAddress, setUserAddress] = useState([]);

  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [buttonTitle, setButtonTitle] = useState(null);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [succeessTitle, setSuccessTitle] = useState(null);
  const [defaultAddressSelected, setDefaultAddressSelected] = useState(null);

  const handleOpenAddressPopup = () => {
    SetOpenNewAddress(true);
  };

  const handleCloseAddressPopup = () => {
    SetOpenNewAddress(false);
  };

  const handleOpenEditressPopup = (rowData) => {
    setOpenEditAddress(true);
    setSelectedData(rowData);
  };

  const handleCloseEditAddressPopup = () => {
    setOpenEditAddress(false);
  };

  const handleOpendeletePopup = (rowId) => {
    setOpenDeleteConfirmation(true);
    setSelectedRowId(rowId);
  };

  const handleClosedeletePopup = () => {
    setOpenDeleteConfirmation(false);
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  const handlefetchAddress = async () => {
    setAddressloading(true);
    try {
      const response = await getAdressOfUser({
        user_id: parseInt(userId),
      });

      setUserAddress(response?.data);
      setAddressloading(false);
      const selectedAddress = response?.data?.find(
        (i) => i.is_default === true
      );

      if (selectedAddress) {
        setDefaultAddressSelected(selectedAddress?.id); // Local state
        dispatch(setDefaultAddress(selectedAddress?.id)); // Redux
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setAddressloading(false);
    }
  };

  useEffect(() => {
    handlefetchAddress(userId);
  }, [userId]);

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  const handleCancelAddress = async () => {
    try {
      const response = await deleteUserAddress({
        user_id: parseInt(userId),
        id: selectedRowId,
      });

      if (response.statusCode === 200) {
        handleClosedeletePopup();
        handleOpenSuccessPopup();
        setSuccessTitle("Address Deleted Successfully !!");
      } else if (response.statusCode === 400) {
        setErrorMessage(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Got It");
      } else if (response.statusCode === 404) {
        setErrorMessage(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Got It");
      } else if (response.statusCode === 500) {
        setErrorMessage(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      } else {
        setErrorMessage("Internal Server Error");
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      }
    } catch (error) {
      setErrorMessage("Internal Server Error");
      handleOpenErrorPopup();
      setButtonTitle("Try Again");
    }
  };

  const handlesetDefaultAddress = (address) => {
    const selectedAddress = userAddress?.find((i) => i.id === address.id);

    if (selectedAddress) {
      setDefaultAddressSelected(selectedAddress.id); // Local state
      dispatch(setDefaultAddress(selectedAddress.id)); // Redux
    }
  };

  return (
    <>
      <GlobalCard height="100%">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              textAlign="start"
              color="#572575"
              fontFamily="Inter"
              fontSize="20px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Billing Address
            </Typography>
          </Grid>

          {userAddress?.length > 0 && (
            <Grid item xs={6} textAlign="end">
              <PinkExtraSmallButton
                buttonTitle="Add New"
                startIcon={<AddCircleIcon />}
                onClick={handleOpenAddressPopup}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{
                height: { xs: "auto", md: 400 }, // fixed height for scroll area
                overflowY: "auto", // vertical scroll when content overflows
                pr: 1, // padding right to avoid scrollbar overlap
              }}
            >
              {addressLoading && <Loader text="Loading Address" />}

              {!addressLoading && userAddress?.length === 0 && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                >
                  <NoAddressScreen />
                </Box>
              )}

              <Grid container spacing={2}>
                {userAddress?.length > 0 &&
                  [...userAddress]
                    .sort(
                      (a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0)
                    )
                    .map((address, index) => (
                      <Grid item xs={12}>
                        <Card
                          onClick={() => handlesetDefaultAddress(address)}
                          sx={{
                            border:
                              defaultAddressSelected === address?.id
                                ? "1px solid #572575"
                                : "1px solid #DDDDDD",

                            boxShadow:
                              defaultAddressSelected === address?.id
                                ? "0px 4px 12px rgba(0,0,0,0.2)"
                                : "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                            padding: "10px",
                            width: "100%",
                            borderRadius: "8px",
                            background:
                              defaultAddressSelected === address?.id
                                ? "#FBF4FF"
                                : "#FFFFFF",
                            px: { xs: 1, sm: 2, md: 2 },
                            // "&:hover": {
                            //   border: "2px solid #FFE2FA",
                            //   //   boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
                            // },
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Typography
                                textAlign="start"
                                color="#572575"
                                fontFamily="Inter"
                                fontSize="18px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                {address?.is_default
                                  ? "Default Address"
                                  : `Address  ${index}`}
                              </Typography>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              sm={6}
                              display="flex"
                              justifyContent="flex-end"
                              alignItems="center"
                              gap={2}
                            >
                              <Box
                                width={24}
                                onClick={(e) => {   e.stopPropagation();
                                   handleOpenEditressPopup(address)} }
                              >
                                <img src="/newdashboard/Checkout/Group 1171283810.png" />
                              </Box>
                              {address?.is_default === true ? (
                                <Tooltip title="Please set a different address as the default before deleting this one">
                                  <Box
                                    width={24}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (address?.is_default === false) {
                                        handleOpendeletePopup(address?.id);
                                      }
                                    }}
                                    sx={{
                                      opacity:
                                        address?.is_default === true && "25%",
                                    }}
                                  >
                                    <img src="/newdashboard/Checkout/Group 1171283811.png" />
                                  </Box>
                                </Tooltip>
                              ) : (
                                <Box
                                  width={24}
                                  onClick={(e) =>{
                                    e.stopPropagation();
                                    handleOpendeletePopup(address?.id)
                                  }}
                                >
                                  <img src="/newdashboard/Checkout/Group 1171283811.png" />
                                </Box>
                              )}
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                {/* name */}
                                <Grid item xs={12} sm={6} md={3}>
                                  <Typography
                                    color="#555555"
                                    fontFamily="Inter"
                                    fontSize="14px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    fontStyle="normal"
                                    style={{ fontWeight: 400 }}
                                  >
                                    Name :{" "}
                                    <span style={{ color: "#000000" }}>
                                      {address?.name}
                                    </span>
                                  </Typography>
                                </Grid>

                                {/* country */}

                                <Grid item xs={12} sm={6} md={3}>
                                  <Typography
                                    color="#555555"
                                    fontFamily="Inter"
                                    fontSize="14px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    fontStyle="normal"
                                    style={{ fontWeight: 400 }}
                                  >
                                    Country :{" "}
                                    <span style={{ color: "#000000" }}>
                                      {address?.country?.country_name}
                                    </span>
                                  </Typography>
                                </Grid>

                                {/* State */}

                                <Grid item xs={12} sm={6} md={6}>
                                  <Typography
                                    color="#555555"
                                    fontFamily="Inter"
                                    fontSize="14px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    fontStyle="normal"
                                    style={{ fontWeight: 400 }}
                                  >
                                    State :{" "}
                                    <span style={{ color: "#000000" }}>
                                      {address?.state?.state_name}
                                    </span>
                                  </Typography>
                                </Grid>

                                {/* city */}
                                <Grid item xs={12} sm={6} md={3}>
                                  <Typography
                                    color="#555555"
                                    fontFamily="Inter"
                                    fontSize="14px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    fontStyle="normal"
                                    style={{ fontWeight: 400 }}
                                  >
                                    City :{" "}
                                    <span style={{ color: "#000000" }}>
                                      {address?.city?.city_name}
                                    </span>
                                  </Typography>
                                </Grid>

                                {/* zip code */}
                                <Grid item xs={12} sm={6} md={3}>
                                  <Typography
                                    color="#555555"
                                    fontFamily="Inter"
                                    fontSize="14px"
                                    lineHeight="100%"
                                    letterSpacing="0px"
                                    fontStyle="normal"
                                    style={{ fontWeight: 400 }}
                                  >
                                    Zip Code :{" "}
                                    <span style={{ color: "#000000" }}>
                                      {address?.zip_code}
                                    </span>
                                  </Typography>
                                </Grid>

                                {/* address */}
                                <Grid item xs={12} sm={6} md={6}>
                                  <Typography
                                    color="#555555"
                                    fontFamily="Inter"
                                    fontSize="14px"
                                    lineHeight="1.4"
                                    letterSpacing="0px"
                                    fontStyle="normal"
                                    style={{ fontWeight: 400 }}
                                  >
                                    Street Address :{" "}
                                    <span style={{ color: "#000000" }}>
                                      {address?.address}
                                    </span>
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </GlobalCard>

      <CustomPopup
        handleClose={handleCloseAddressPopup}
        component={
          <AddNewAddress
            handleClose={handleCloseAddressPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setSuccessTitle={setSuccessTitle}
          />
        }
        open={OpenNewAddress}
        subtitle=""
        maxWidth="sm"
      />

      <CustomPopup
        handleClose={handleCloseEditAddressPopup}
        component={
          <EditUserAddress
            handleClose={handleCloseEditAddressPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            selectedData={selectedData}
            setSuccessTitle={setSuccessTitle}
          />
        }
        open={OpenEditAddress}
        subtitle=""
        maxWidth="sm"
      />

      <SussceeffulyMessageScreen
        text={succeessTitle}
        subText=""
        buttonTitle="Thanks, Got it"
        startIcon={<DoneIcon />}
        navigateLink="/test-prep/checkout"
        currentLink={location.pathname}
        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
      />

      <DeleteConfirmationPopup
        open={openDeleteConfirmation}
        text="Delete Address Permanently ?"
        subtext="Oops! Are you sure you want to remove this address? You won’t be able to get it back."
        buttonTitle="Yes, Remove It"
        handleClose={handleClosedeletePopup}
        handleSubmit={handleCancelAddress}
      />

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle={buttonTitle}
        // startIcon={<ArticleIcon />}
        navigateLink="/test-prep/checkout"
        currentPathname={location.pathname}
        maxWidth="xs"
      />
    </>
  );
}
